import React from 'react';
import {mathCalculators_En } from '../ConstantsEN';
import SharedHelmet from '../Helmet';
const TITLE = 'Math Calculators - Free Tools for Percentage, Areas, and Geometric Shapes';
const DESCRIPTION = 'Explore a collection of free math calculators, including percentage calculators, area calculations, and various geometric computations.';
const KEYWORDS = 'Math calculators, Free calculators, Percentage calculator, Median calculator, Cylinder circumference calculator, Tank area calculator, Square side length calculator, Attendance and absence rate calculator, Population density calculator, Five times calculator, 5% percentage calculator, 10% percentage calculator, 15% percentage calculator, 20% percentage calculator, 25% percentage calculator, 30% percentage calculator, 35% percentage calculator, 40% percentage calculator, 75% percentage calculator';
const NOTE = 'If you know or want to add other calculators, please contact us by email at info@do-calculate.com. We will be happy to add them! :)';
const OG_URL = 'https://do-calculate.com/en/math-calculators';
function CalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div>
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION}</p>
                </div>
                <div className="alert alert-info" role="alert">
                    <u><p>{NOTE}</p></u>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr>
                        <th >Calculator</th>
                        <th >Description</th>
                    </tr>
                </thead>
                <tbody>
                    {mathCalculators_En.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
